import { authConfig, updateAuthConfig } from '../config/authConfig'

class AuthService {
  constructor() {
    this.tokens = null
    this.user = null
    this.refreshTimer = null
    this.loadStoredData()
  }

  loadStoredData() {
    const storedTokens = localStorage.getItem(authConfig.tokenStorageKey)
    const storedUser = localStorage.getItem(authConfig.userStorageKey)

    if (storedTokens) {
      this.tokens = JSON.parse(storedTokens)
    }
    if (storedUser) {
      this.user = JSON.parse(storedUser)
    }
  }

  async login(credentials) {
    try {
      // const response = await fetch(`${authConfig.authServerUrl}${authConfig.endpoints.login}`, {
      const params = new URLSearchParams()
      params.append('grant_type', `${authConfig.grant_type}`)
      params.append('client_id', `${authConfig.clientId}`)
      params.append('client_secret', `${authConfig.clientSecret}`)
      params.append('scope', `${authConfig.scope}`)
      params.append('username', `${credentials.username}`)
      params.append('password', `${credentials.password}`)

      const response = await fetch(`${authConfig.authServerUrl}${authConfig.endpoints.login}`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: params,
      })

      if (!response.ok) {
        throw new Error('Ошибка аутентификации')
      }

      const data = await response.json()
      // console.log("Data: " + JSON.stringify(data.access_token));
      this.setAuthData(data)

      return { success: true }
    } catch (error) {
      console.error('Login error:', error)
      return { success: false, error: error.message }
    }
  }

  async fetchCurrentUserInfo() {
    // if (!token) return;
    //
    // setLoading(true);
    // console.log("Get userinfo with token: " + this.getToken())
    try {
      const response = await fetch(`${authConfig.authServerUrl}${authConfig.endpoints.userInfo}`, {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${this.getToken()}`,
          'Content-Type': 'application/json',
        },
      })

      const data = await response.json()
      console.log('User info:', data)
      this.user = data.user || {
        id: data.sub,
        username: data.name,
        email: data.email,
        login: data.preferred_username,
        avatar: data.avatar || this.getInitials(data.username),
      }
      console.log("Save current user: " + JSON.stringify(this.getUser()));
      this.saveUser();

      return data
    } catch (err) {
      console.error('Ошибка:', err)
    }
  };

  async register(userData) {
    try {
      const response = await fetch(`${authConfig.authServerUrl}${authConfig.endpoints.register}`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(userData),
      })

      if (!response.ok) {
        throw new Error('Ошибка регистрации')
      }

      const data = await response.json()
      this.setAuthData(data)
      return { success: true, user: this.user }
    } catch (error) {
      console.error('Registration error:', error)
      return { success: false, error: error.message }
    }
  }

  async logout() {
    if (this.tokens?.accessToken) {
      try {
        const params = new URLSearchParams()
        params.append('client_id', `${authConfig.clientId}`)
        params.append('client_secret', `${authConfig.clientSecret}`)
        params.append('refresh_token', `${this.getRefreshToken()}`)

        const response = await fetch(`${authConfig.authServerUrl}${authConfig.endpoints.logout}`, {
          method: 'POST',
          headers: {
            // 'Authorization': `Bearer ${this.getToken()}`,
            'Content-Type': 'application/x-www-form-urlencoded',
          },
          body: params,
        });

        const data = await response.json();
        console.log('Refresh token info:', data);
      } catch (error) {
        console.error('Refresh token error:', error);
      }
    }

    this.clearAuthData()
    return { success: true }
  }

  async refreshToken() {
    if (!this.tokens?.refreshToken) {
      return false
    }

    try {
      const params = new URLSearchParams()
      params.append('grant_type', 'refresh_token')
      params.append('client_id', `${authConfig.clientId}`)
      params.append('client_secret', `${authConfig.clientSecret}`)
      params.append('refresh_token', `${this.getRefreshToken()}`)

      const response = await fetch(`${authConfig.authServerUrl}${authConfig.endpoints.refresh}`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        },
        body: JSON.stringify({ refreshToken: this.tokens.refreshToken }),
      })

      if (!response.ok) {
        throw new Error('Token refresh failed')
      }

      const data = await response.json()
      this.tokens = data
      this.saveTokens()
      this.startRefreshTimer()
      return true
    } catch (error) {
      console.error('Token refresh error:', error)
      this.clearAuthData()
      return false
    }
  }

  setAuthData(data) {
    console.log('Tokens: ' + JSON.stringify(data.access_token))
    this.tokens = {
      accessToken: data.access_token,
      refreshToken: data.refresh_token,
      expiresIn: data.expires_in,
      tokenType: data.token_type || 'Bearer',
    }
    console.log('AT: ' + JSON.stringify(this.tokens.accessToken))

    this.user = data.user || {
      id: data.sub,
      username: data.name,
      email: data.email,
      login: data.preferred_username,
      avatar: data.avatar || this.getInitials(data.username),
    }

    this.saveTokens()
    console.log('getToken: ' + this.getToken())
    console.log('getRefreshToken: ' + this.getRefreshToken())
    this.saveUser()
    this.startRefreshTimer()
  }

  saveTokens() {
    localStorage.setItem(authConfig.tokenStorageKey, JSON.stringify(this.tokens))
  }

  saveUser() {
    localStorage.setItem(authConfig.userStorageKey, JSON.stringify(this.user))
  }

  clearAuthData() {
    this.tokens = null
    this.user = null
    localStorage.removeItem(authConfig.tokenStorageKey)
    localStorage.removeItem(authConfig.userStorageKey)
    if (this.refreshTimer) {
      clearTimeout(this.refreshTimer)
    }
  }

  startRefreshTimer() {
    if (this.refreshTimer) {
      clearTimeout(this.refreshTimer)
    }

    if (this.tokens?.expiresIn) {
      const refreshTime = (this.tokens.expiresIn - authConfig.refreshThreshold) * 1000
      this.refreshTimer = setTimeout(() => {
        this.refreshToken()
      }, refreshTime)
    }
  }

  isAuthenticated() {
    return !!this.tokens?.accessToken
  }

  getUser() {
    return this.user
  }

  getToken() {
    return this.tokens?.accessToken
  }

  getRefreshToken() {
    return this.tokens?.refreshToken
  }

  getInitials(name) {
    return name ? name.charAt(0).toUpperCase() : '?'
  }

  // Метод для обновления URL сервера аутентификации
  updateServerUrl(newUrl) {
    authConfig.authServerUrl = newUrl
    localStorage.setItem('auth_config', JSON.stringify(authConfig))
  }
}

export default new AuthService()
